import { Injectable } from "@angular/core";
import { ApiService } from "../../core/services/api.service";
import { SessionStateService } from "../../core/services/session-state.service";
import { Observable } from "rxjs/Observable";
import { environment } from "../../../environments/environment";
import { TARIFF_TYPES } from "../../shared/constants";
import { HOUSE_GEOGRAPHY } from "../houses/houses.constants";

const PORTAL_SOURCE = "portal";

@Injectable()
export class EfficiencyService {
  cursor: string = null;
  constructor(
    private apiService: ApiService,
    private sessionStateService: SessionStateService
  ) {}

  getRedyTips(): Observable<any> {
    const houseId = this.sessionStateService.getHouse().houseId;
    if (houseId !== undefined) {
      return this.apiService.get(`/efficiency/house/${houseId}/tarifftips`);
    } else {
      return Observable.throw("");
    }
  }

  optimizePowerTip(
    type,
    geography,
    currentContractedPower,
    newContractedPower
  ): Observable<any> {
    const houseId = this.sessionStateService.getHouse().houseId;

    const body = {
      type,
      geography,
      newContractedPower,
      currentContractedPower,
      source: PORTAL_SOURCE,
    };

    if (houseId !== undefined) {
      return this.apiService.post(
        `/efficiency/house/${houseId}/optimizeHouseTariff`,
        body
      );
    } else {
      return Observable.throw("");
    }
  }

  optimizeCycleTip(
    type,
    geography,
    currentHourOption,
    newHourOption,
    currentCycle,
    newCycle
  ): Observable<any> {
    const houseId = this.sessionStateService.getHouse().houseId;

    const body = {
      type,
      geography,
      currentHourOption,
      newHourOption,
      currentCycle,
      newCycle,
      source: PORTAL_SOURCE,
    };

    if (houseId !== undefined) {
      return this.apiService.post(
        `/efficiency/house/${houseId}/optimizeHouseTariff`,
        body
      );
    } else {
      return Observable.throw("");
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/entities/efficiency/efficiency.service.ts